import { useTranslation } from 'react-i18next';
import CategoryCard from '@/components/base/CategoryCard';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            {t('categories.title')}
          </h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">
            {t('categories.subtitle')}
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
          {categories.map((cat) => (
            <CategoryCard
              key={cat.id}
              id={cat.id}
              name={cat.name}
              icon={cat.icon}
              description={cat.description}
              image={cat.image}
            />
          ))}
        </div>
      </div>
    </section>
  );
}